/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const VideoCircledIcon = /*#__PURE__*/ createSvgIcon(
  'VideoCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle
              cx={10}
              cy={10}
              r={10}
              fill="var(--cds-color-emphasis-neutral-background-weak)"
            />
            <path
              d="M8.922 12.5l3.484-2.234a.3.3 0 00.14-.266.3.3 0 00-.14-.266L8.922 7.5a.278.278 0 00-.32-.016.304.304 0 00-.165.282v4.468c0 .125.055.22.165.282.109.062.216.057.32-.016zM5 15c-.344 0-.638-.122-.883-.367a1.204 1.204 0 01-.367-.883v-7.5c0-.344.122-.638.367-.883S4.657 5 5 5h10c.344 0 .638.122.883.367s.367.54.367.883v7.5c0 .344-.122.638-.367.883A1.204 1.204 0 0115 15H5zm0-1.25h10v-7.5H5v7.5z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default VideoCircledIcon;
